import React from 'react';
import { MdEventAvailable } from 'react-icons/md';
import i18n from '../../i18n';
import { LESSON_SCHEDULE_CALENDAR_URL } from '../../constants/axios';
import { COMMON_ADD_LESSON_TO_CALENDAR } from '../../constants/translationLabels/common';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const CalendarLessonLink = ({ scheduleId }) => {
    if (!scheduleId) return null;

    const label = i18n.t(COMMON_ADD_LESSON_TO_CALENDAR);
    const href = `${BASE_URL}${LESSON_SCHEDULE_CALENDAR_URL}`
        + `?scheduleId=${scheduleId}&language=${i18n.language}`;

    return (
    <a
        href={href}
    title={label}
    aria-label={label}
    rel="noreferrer noopener"
    className="lesson-calendar-link"
    download
    >
    <MdEventAvailable className="svg-btn" />
        </a>
);
};

export default CalendarLessonLink;
